// src/components/ModalUpgradePlano.jsx
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaLock, FaCrown, FaRocket } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import {
  FEATURES,
  PLAN_LABELS,
  PLAN_COLORS,
} from '../hooks/usePlanAccess';

const PLAN_ICONS = {
  BASIC:      <FaLock />,
  PRO:        <FaRocket />,
  ENTERPRISE: <FaCrown />,
};

export default function ModalUpgradePlano({
  show,
  featureKey,
  currentTier,
  onClose,
}) {
  const navigate = useNavigate();

  if (!featureKey) return null;

  const feature      = FEATURES[featureKey];
  const requiredPlan = feature.requiredPlan;
  const requiredColor = PLAN_COLORS[requiredPlan];
  const currentColor  = PLAN_COLORS[currentTier];

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="d-flex align-items-center gap-2">
          <FaLock className="text-warning" />
          Funcionalidade bloqueada
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center py-4">
        <div
          className="d-inline-flex align-items-center justify-content-center mb-3"
          style={{
            width:           72,
            height:          72,
            borderRadius:    '50%',
            backgroundColor: `${requiredColor}20`,
            color:           requiredColor,
            fontSize:        32,
          }}
        >
          {PLAN_ICONS[requiredPlan]}
        </div>

        <h5 className="mb-2">{feature.label}</h5>
        <p className="text-muted mb-3">{feature.description}</p>

        <div className="alert alert-light border mb-3">
          <small className="text-muted d-block mb-1">Seu plano atual</small>
          <strong style={{ color: currentColor }}>
            {PLAN_LABELS[currentTier]}
          </strong>

          <div className="my-2" style={{ fontSize: 20 }}>⬇️</div>

          <small className="text-muted d-block mb-1">Plano necessário</small>
          <strong style={{ color: requiredColor, fontSize: 18 }}>
            {PLAN_LABELS[requiredPlan]}
          </strong>
        </div>

        <small className="text-muted">
          Faça upgrade para desbloquear essa e outras funcionalidades avançadas.
        </small>
      </Modal.Body>

      <Modal.Footer className="border-0 justify-content-center gap-2">
        <Button variant="outline-secondary" onClick={onClose}>
          Agora não
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            onClose();
            navigate('/upgrade'); // 👈 ajuste pra sua rota
          }}
        >
          <FaRocket className="me-1" /> Ver planos
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
